import React, { FC, useCallback } from 'react';
import { TerminationReasonModel } from '@utmost.co/enterprise-models';
import { DataTableRowAction, DataTableRowActions } from '@utmost.co/utmost-design-system';
import { tokens } from '@beeline.com/bp-design-system';
import { useTerminationReasonsIntl } from './translations/useTerminationReasonsIntl';

interface Props {
  onEdit: (terminationReason: TerminationReasonModel) => void;
  onDelete: (uid: string) => void;
  terminationReason: TerminationReasonModel;
}

export const TerminationReasonActions: FC<React.PropsWithChildren<Props>> = ({
  onEdit,
  onDelete,
  terminationReason
}) => {
  const intl = useTerminationReasonsIntl();
  const canDelete = terminationReason.sourceName === 'UTMOST';

  const handleDelete = useCallback(() => onDelete(terminationReason.uid), [onDelete, terminationReason.uid]);

  return (
    <DataTableRowActions actionsLabel={intl.actions} dataTest="termination-actions">
      <DataTableRowAction onClick={() => onEdit(terminationReason)} dataTest="overflow__action__edit">
        {intl.update}
      </DataTableRowAction>
      <DataTableRowAction
        disabledMessage={intl.missingPermissions}
        disabled={!canDelete}
        style={{ color: tokens.colorAlert }}
        onClick={handleDelete}
        dataTest="overflow__action__delete"
      >
        {intl.delete}
      </DataTableRowAction>
    </DataTableRowActions>
  );
};
